/**
 *  @class
 *  @function Pagination
 */

if (!customElements.get('pagination-theme')) {
  class Pagination extends HTMLElement {
    constructor() {
      super();
      const id = this.dataset.section;
      this.button = this.querySelector('.load-more');
      this.pagination = this.closest('#pagination');
      this.grid = document.querySelector(`[data-id="${id}"]`);
    }

    connectedCallback() {
      if (this.classList.contains('pagination-type--loadmore')) {
        this.initLoadMore();
      }
      if (this.classList.contains('pagination-type--infinite')) {
        this.initInfiniteScroll();
      }
    }

    initLoadMore() {
      this.button.addEventListener('click', () => {
        this.loadProducts();
        this.button.blur();
      });
    }

    initInfiniteScroll() {
      this.observer = new IntersectionObserver(entries => {
        if (entries[0].intersectionRatio === 1) {
          this.loadProducts();
        }
      }, {
        threshold: [0, 1]
      });
      this.observer.observe(this);
    }

    async loadProducts() {
      if (this.hasAttribute('loading')) return;

      const nextPageUrl = this.pagination?.dataset?.nextPage;
      if (!nextPageUrl) {
        if (this.observer) this.observer.unobserve(this);
        if (this.button) this.button.classList.add('visually-hidden');
        return;
      }

      this.setAttribute('loading', 'true');

      try {
        const response = await fetch(nextPageUrl);
        const responseText = await response.text();
        this.renderProducts(responseText, nextPageUrl);

        dispatchCustomEvent('pagination:page-changed', { url: nextPageUrl });
      } catch (error) {
        console.error('Error loading products:', error);
      } finally {
        this.removeAttribute('loading');
      }
    }

    renderProducts(html, url) {
      const parsed = new DOMParser().parseFromString(html, 'text/html');

      const gridToReplace = parsed.getElementById('product-grid');
      const paginationEl = parsed.getElementById('pagination');

      if (!gridToReplace) {
        if (this.observer) this.observer.unobserve(this);
        if (this.button) this.button.classList.add('visually-hidden');
        return;
      }

      /* replace pagination HTML */
      if (paginationEl && this.pagination) {
        this.pagination.innerHTML = paginationEl.innerHTML;

        /* sync next page url */
        if (paginationEl.dataset?.nextPage) {
          this.pagination.dataset.nextPage = paginationEl.dataset.nextPage;
        } else {
          this.pagination.removeAttribute('data-next-page');
        }
      }

      const products = gridToReplace.querySelectorAll('.columns');
      products.forEach((product) => {
        this.grid.appendChild(product);
        product.querySelectorAll('.lazyload').forEach((image) => {
          if (window.lazySizes) {
            lazySizes.loader.unveil(image);
          }
        });
      });
    }
  }

  customElements.define('pagination-theme', Pagination);
}
